export enum BusinessMachineCover {
  CASCO_MACHINE = 'CASCO_MACHINE',
  MACHINE_BREAKAGE = 'MACHINE_BREAKAGE',
}

export const getBusinessMachineCoverLabel = (cover: BusinessMachineCover) => {
  switch (cover) {
    case BusinessMachineCover.CASCO_MACHINE:
      return $localize`Casco machine`;
    case BusinessMachineCover.MACHINE_BREAKAGE:
      return $localize`Bris de machine`;
  }
};
